'use strict';

var d3 = require('d3');
var $ = require('jquery');
var _ = require('lodash');
/**
 * Single rectangle
 *
 * Draws static rectangle
 *
 * @param d3Helper
 * @param tooltip
 * @returns {Function}
 * @constructor
 */
var SingleRectangle = function SingleRectangle(d3Helper, tooltip) {
  return function (xPropertyName, yPropertyName, tooltipContentProvider) {
    var params, scales, data, customHeight, tip;
    var tooltipId = _.uniqueId('single-rectangle-tooltip-');
    var dataIsSet = false;
    var offsetY = 0;
    var offsetX = 0;
    var rootClassName = 'group-single-rectangle';
    var className = rootClassName + '-' + xPropertyName;
    var tooltipSelector;
    var tooltipInitialized;
    var tooltipAdded = tooltipContentProvider !== undefined;
    if (tooltipAdded) {
      var tooltipClasses = tooltipContentProvider.cssClass ? tooltipContentProvider.cssClass + ' ' + tooltipId : tooltipId;
      tip = tooltip(tooltipContentProvider, tooltipClasses);
      tooltipSelector = '.' + tooltipId;
    }
    var mouseOverHandler = function mouseOverHandler(d) {
      if (tooltipAdded) {
        tip.show(d, this);
        tip.setPositionNearCursor(tooltipSelector);
      }
    };
    var mouseMoveHandler = function mouseMoveHandler() {
      if (tooltipAdded) {
        tip.setPositionNearCursor(tooltipSelector);
      }
    };
    var mouseOutHandler = function mouseOutHandler() {
      if (tooltipAdded) {
        tip.hideAndAdjustPosition();
      }
    };

    /**
     * Binds event to group DOM element
     * @param selection
     */
    function bindEvents(selection) {
      if (tooltipAdded) {
        selection.on('mouseout', mouseOutHandler);
        selection.on('mousemove', mouseMoveHandler);
        selection.on('mouseover', mouseOverHandler);
      }
    }

    /**
     * Unbinds event from a group DOM element
     * @param selection
     */
    function unbindEvents(selection) {
      selection.on('mouseout', null);
      selection.on('mousemove', null);
      selection.on('mouseover', null);
    }
    function getBarWidth(d) {
      var val1 = 0;
      if (xPropertyName) {
        val1 = d[xPropertyName];
      }
      var val2 = 0;
      if (yPropertyName) {
        val2 = d[yPropertyName];
      }
      return Math.abs(scales.xScale(val1) - scales.xScale(val2));
    }
    function getBarHeight() {
      if (!_.isNil(customHeight)) {
        return customHeight;
      } else {
        return _.max(scales.yScale.rangeExtent());
      }
    }
    var rectangle = function rectangle(container) {
      var mainGroup = d3Helper.findChildrenByClass(container, className);
      if (mainGroup.empty()) {
        mainGroup = d3Helper.createGroupElement(container, [rootClassName, className].join(' '));
      } else {
        mainGroup.html('');
      }
      var barHeight = getBarHeight();
      var singleRectangle = mainGroup.selectAll(className).data(data);
      var g = singleRectangle.enter().append('g').call(bindEvents).attr({
        transform: function transform(d) {
          var val = 0;
          if (xPropertyName) {
            val = d[xPropertyName];
          }
          return 'translate(' + [scales.xScale(val) + offsetX, 0] + ')';
        }
      });
      singleRectangle.exit().call(unbindEvents).remove();
      g.append('rect').attr({
        'class': function _class(d) {
          return ['single-rectangle', d.className].join(' ');
        },
        x: 0,
        y: 0,
        width: getBarWidth,
        height: barHeight
      });
      if (!tooltipInitialized && tooltipAdded) {
        singleRectangle.call(tip);
        tooltipInitialized = true;
      }
    };

    /**
     *
     * @param {Array} value
     * @returns {rectangle}
     */
    rectangle.withData = function (value) {
      dataIsSet = true;
      data = value;
      return rectangle;
    };
    rectangle.params = function (value) {
      params = value;
      return rectangle;
    };
    rectangle.scales = function (value) {
      scales = value;
      return rectangle;
    };
    rectangle.withCustomHeight = function (value) {
      customHeight = value;
      return rectangle;
    };
    rectangle.withOffsetX = function (value) {
      offsetX = value;
      return rectangle;
    };
    rectangle.withOffsetY = function (value) {
      offsetY = value;
      return rectangle;
    };
    rectangle.destroy = function () {
      if (tooltipAdded) {
        $(tooltipSelector).remove();
      }
    };
    return rectangle;
  };
};
SingleRectangle.$inject = ['d3Helper', 'ChartElementsTooltip'];
module.exports = SingleRectangle;